import React from 'react';
import { map } from 'lodash-es';

import { useTrans } from '@/custom-hooks/useTrans';

import styles from './field-errors.module.scss';

type FieldErrorsProps = {
    fieldId: string;
    errors: any;
};
export default function FieldErrors(props: FieldErrorsProps) {
    const { t } = useTrans();
    const { errors, fieldId } = props;

    return errors?.[fieldId]?.types ? (
        <div key={`${fieldId}_error_container`} className={styles.fieldErrorMessage}>
            {map(errors?.[fieldId]?.types, (error, type) => {
                const errorString =
                    error?.indexOf?.('I18N:') !== -1 ? t(error?.replace?.('I18N:', '')) : error;
                const errorMessage =
                    typeof errorString === 'string'
                        ? errorString
                        : t('common:labels.missingRequiredField');

                return (
                    <div key={`${fieldId}_${type}`}>
                        <small key={`${fieldId}_${type}_error`}>{errorMessage}</small>
                        <br key={`${fieldId}_${type}_linebreak`} />
                    </div>
                );
            })}
        </div>
    ) : (
        <small key={`${fieldId}_${errors?.[fieldId]?.type}`}>{errors?.[fieldId]?.message}</small>
    );
}
